import { Resume } from '@rio/types'
import { useI18n } from 'builder/hooks/useI18n'
import { SettingsFieldChangeHandler } from 'builder/modules/resumeEditor'
import { useTextCustomization } from 'builder/components/DocumentCustomizationModal/components/ResumeSidebar/hooks/useTextCustomization'

import { SlideInput } from '../../SlideInput/SlideInput'
import { TEXT_TAB_TRANSLATION } from '../constants'
import * as Styles from './styles'

type Props = {
  resume: Resume
  handleSettingsFieldChange?: SettingsFieldChangeHandler
}

export const OldFontSize = ({ resume, handleSettingsFieldChange }: Props) => {
  const { i18n } = useI18n()
  const { size, supportsFontSizing } = useTextCustomization(resume)
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const displayValues: Record<string, string> = { 0: 'S', 0.5: 'M', 1: 'L' }

  const handleChange = (value: number) => {
    handleSettingsFieldChange?.('fontSize', value, size)
  }

  return (
    <Styles.Container>
      <SlideInput
        withMarks
        min={0}
        max={1}
        step={0.5}
        unit="%"
        value={size}
        defaultValue={size}
        onChange={handleChange}
        disabled={!supportsFontSizing}
        displayValue={displayValues[size]}
        name={i18n.t(`${TEXT_TAB_TRANSLATION}.font_size.title`)}
        disabledTooltip={i18n.t(`${TEXT_TAB_TRANSLATION}.font_size.disabled_tooltip`)}
      />
    </Styles.Container>
  )
}
